import { Injectable, inject } from '@angular/core';
import { IndexType } from '@fnModels/algolia/algolia';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';
import * as actions from './actions';
import { LeapApiService } from 'src/app/shared/api-repos/leap/leap-api.service';
import { AlgoliaLawFirmEmployee } from '@fnModels/algolia/lawfirm';
import { AlgoliaHit } from '@state/utils/models';

export type LawyerSearchStateModel = AlgoliaBaseState<unknown>;

@State<LawyerSearchStateModel>({
	name: 'lawyerSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class LawyerSearchState extends AlgoliaSearchState<LawyerSearchStateModel> {
	private leapApiService = inject(LeapApiService);
	protected indexName = getIndex(IndexType.LAW_FIRM_EMPLOYEES);

	@Selector([LawyerSearchState])
	static getList(state: LawyerSearchStateModel) {
		return state?.items;
	}

	@Selector([LawyerSearchState])
	static getSearching(state: LawyerSearchStateModel) {
		return state?.searching;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<LawyerSearchStateModel>,
		{ payload }: actions.Search,
	) {
		const facetFilters = [];

		if (payload.lawFirmId) {
			facetFilters.push(`lawFirmId:${payload.lawFirmId}`);
		}
		if (payload.role) {
			facetFilters.push(`role:${payload.role}`);
		}

		// if (this.store.selectSnapshot(SelectedMatter.isLeapMatter)) {
		// 	await this.searchLeap(
		// 		ctx,
		// 		`${payload.searchValue}&cardId=${payload.cardId}`,
		// 	);
		// } else {
		await this.algoliaSearchHandler(ctx, payload.searchValue, {
			userToken: this.user.id,
			facetFilters,
		});
		//}
	}

	async searchLeap(
		{ patchState }: StateContext<LawyerSearchStateModel>,
		searchTerm: string,
	) {
		patchState({
			searching: true,
			searchTerm,
			success: false,
			error: null,
			items: [],
		});
		if (!searchTerm) return;
		const results = await this.leapApiService
			.searchLawyers(searchTerm)
			.toPromise();

		patchState({
			success: true,
			searching: false,
			items: results as AlgoliaHit<AlgoliaLawFirmEmployee>[],
		});
	}
}
